module.exports = __webpack_public_path__ + "static/media/heydoor_word_black.abd3f54b.png";